<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    centered
    @ok="handleOk"
    :bodyStyle="{'height':'500px','overflow':'auto'}"
    @cancel="handleCancel"
    cancelText="关闭">
    <div class="" >
      <a-form :form="form">
        <div class="info-content" style="padding-top:25px;padding-bottom:30px;">
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 20 }"
                label="题干   ">
                <!-- <j-editor
                  v-model="children.stem"
                  triggerChange></j-editor> -->
                <vue-ueditor-wrap v-model="children.stem" editor-id="editor-stem"></vue-ueditor-wrap>
                <!-- <j-editor
                  v-decorator="[ 'stem', {} ,{}]"
                  triggerChange></j-editor> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 20 }"
                label="选项"
              >
                <div class="j-teacher-add" style="margin-top:4px;margin-bottom:10px;">
                  <a-button
                    style="color:rgb(208, 219, 228);text-align:center;text-shadow:none;width:100%;line-height:34px;height:34px;font-size:14px;background-color:#F4F5F7;border-color:#D0DBE4"
                    type="primary"
                    icon="plus"
                    @click="addOption"
                  > 新增选项
                  </a-button>
                </div>
                <div class="" >
                  <a-row >
                    <a-col :span="24">
                      <a-form-item
                        style="margin-bottom:12px;"
                        :wrapper-col="{ span: 24 }"
                        label="">
                        <a-radio-group v-model="rightValue" style="width:100%">
                          <div class="item-options" v-for="(data,index) in children.optionList" :key="index">
                            <div class="item-name">{{ data.optionSign }}</div>
                            <vue-ueditor-wrap v-model="data.optionText" :editor-id="'editor-option-'+index" :config="myConfig"></vue-ueditor-wrap>
                            <!-- <a-textarea
                                class="item-form"
                                style="height:80px;resize: none;margin-bottom: 0px;"
                                placeholder="请输入答案"
                                v-model="data.optionText"
                                /> -->
                            <div class="right-item">
                              <a-radio :value="data.optionSign"></a-radio>
                            </div>
                            <div class="item-remove">
                              <a-icon type="delete" style="color:#f5222d" @click="deleteOption(index)"/>
                            </div>
                          </div>
                        <!-- <a-radio-group v-model="value" style="width:100%">
                          <div class="item-options">
                            <div class="item-name">A</div>
                            <a-textarea
                              class="item-form"
                              style="height:80px;resize: none;margin-bottom: 0px;"
                              placeholder="请输入答案"
                              v-decorator="[
                                'answer[0]',
                                {rules: [{ required: true, message: '请输入答案' }]},
                                {}
                              ]" />
                            <div class="right-item">
                              <a-radio value="A"></a-radio>
                            </div>
                            <div class="item-remove">
                              <a-icon type="delete" style="color:#f5222d"/>
                            </div>
                          </div> -->
                        </a-radio-group>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 20 }"
                label="题目分值"
              >
                <a-input
                  placeholder="请输入题目分值"
                  v-decorator="[
                    'score',
                    {rules: [{ required: true, message: '请输入题目分值' }]},
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 20 }"
                label="题目出自"
              >
                <a-input
                  placeholder="请输入题目出自"
                  v-decorator="[
                    'exerciseSrc',
                    {rules: [{ required: true, message: '请输入题目出自' }]},
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 20 }"
                label="知识点"
              >
                <a-input
                  placeholder="请输入知识点"
                  v-decorator="[
                    'knowledgePoints',
                    {rules: [{ required: true, message: '请输入知识点自' }]},
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 8 }"
                label="解析视频   "
              >
                <div class>
                  <div class="clearfix">
                    <j-video-upload
                      v-model="analyseObj"
                      @change="uploadAfter"></j-video-upload>
                    <div style="position: absolute;left:157px;top: 22px;" v-if="downloadData.url">
                      <vue-qr
                        :text="downloadData.url"
                        :margin="0"
                        colorDark="#000"
                        colorLight="#fff"
                        :size="80"></vue-qr>
                    </div>
                    <!-- <a-upload
                      v-decorator="[
                        'analyseUrl',
                        {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: false, message: '请上传视频' }]},
                      ]"
                      listType="picture-card"
                      class="face-picture"
                      :showUploadList="false"
                      :action="videoUploadAction"
                      :headers="headers"
                      :beforeUpload="videoBeforeUpload"
                      @change="videoFullChange"
                    >
                      <span v-if="analyseUrl&&!videoFullloading">已上传</span>
                      <div v-else>
                        <a-icon :type="videoFullloading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text" v-show="videoFullloading">正在上传...</div>
                      </div>
                    </a-upload> -->
                  </div>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 20 }"
                label="解析说明   ">
                <vue-ueditor-wrap v-model="children.analyseDesc" editor-id="editor-children-analyseDesc"></vue-ueditor-wrap>
                <!-- <j-editor
                  v-decorator="[ 'analyseDesc', {} ,{}]"
                  triggerChange></j-editor> -->
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </div>
  </a-modal>
</template>

<script>

  import Vue from 'vue'
  import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
  import JEditor from '@/components/jeecg/JEditor'
  import pick from 'lodash.pick'
  import VueUeditorWrap from 'vue-ueditor-wrap'
  import JVideoUpload from '@/components/jeecg/JVideoUpload'
  import vueQr from 'vue-qr'
  export default {
    name: 'ChildTopicCreateModal',
    components: {
      JEditor,
      VueUeditorWrap,
      JVideoUpload,
      vueQr
    },
    data () {
      return {
        rightValue: '',
        form: this.$form.createForm(this),
        title: '习题编辑',
        width: 1000,
        visible: false,
        headers: {},
        videoFullloading: false,
        downloadData: {
          url: '',
          icon: window._CONFIG['domianURLHttp'] + '/schoolLogo.png'
        },
        videoFull: {
          id: ''
        },
        url: {
          fileUpload: window._CONFIG['domianURL'] + '/sys/common/upload',
          videoUpload: window._CONFIG['domianURL'] + '/sys/common/aliyunVodUpload'
        },
        loading: false,
        optionSign: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
        tokenHeader: '',
        // optionList:[],
        children: {},
        index: 0,
        myConfig: {
          initialFrameHeight: 80
        },
        analyseObj: {
          obsObjectKey: '',
          obsName: ''
        }
      }
    },
    methods: {
      uploadAfter (url) {
        // window._CONFIG['domianURLHttp'] +
        this.downloadData.url = 'https://www.mba-kaoyan.com/mobile/index.html#/videoView?videoId=' + url.obsObjectKey
      },
      // 显示弹框
      open (resultData, index) {
        this.index = index
        console.log(resultData)
        console.log(index)
        this.children = resultData
        // this.analyseUrl = this.children.analyseUrl;
        this.analyseObj = {
          obsObjectKey: this.children.analyseUrl || '',
          obsName: this.children.analyseName || ''
        }
        if (this.analyseObj.obsObjectKey) {
          this.downloadData.url = 'https://www.mba-kaoyan.com/mobile/index.html#/videoView?videoId=' + this.analyseObj.obsObjectKey
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(resultData, 'stem', 'directions', 'score', 'knowledgePoints', 'analyseDesc', 'exerciseSrc', 'analyseUrl'))
        })
        if (resultData.optionList) {
          this.children.optionList = resultData.optionList
          this.children.optionList.forEach(element => {
            if (element.isRight == 1) {
              this.rightValue = element.optionSign
            }
          })
        }
        this.visible = true
      },
      close () {
        this.$emit('close')
        this.visible = false
      },
      deleteOption(index) {
        this.children.optionList.splice(index, 1)
      },
      addOption() {
        if (this.children.optionList.length >= 4) {
          this.$message.warning('最多4个选项！')
        } else {
        var option = {
          exerciseId: this.id,
          isRight: 0,
          optionSign: this.optionSign[this.children.optionList.length],
          optionText: ''
        }
        this.children.optionList.push(option)
        }
      },
      normFile(e) {
        console.log('Upload event:', e)
        if (Array.isArray(e)) {
          return e
        }
        return e && e.file && e.file.response && e.file.response.result
      },

      videoFullChange (info, j, k) {
        if (info.file.status === 'uploading') {
          this.videoFullloading = true
          return
        }

        if (info.file.status === 'done') {
          this.analyseUrl = info.file.response.result.obsObjectKey
          // this.downloadFullData.url = window._CONFIG['domianURLHttp'] + '/mediaPlay?type=1&id=' + this.videoFull.id
          this.videoFullloading = false
        }
      },

      // 音频上传前校验
      videoBeforeUpload (file) {
        const isJPG = /\.(mp4)$/.test(file.name)

        if (!isJPG) {
          this.$message.error('只能上传mp4视频!')
        }

        const isLt10M = file.size / 1024 / 1024 < 500
        if (!isLt10M) {
          this.$message.error('图片大小要小于500MB!')
        }
        return isJPG && isLt10M
      },
      handleOk () {
        this.form.validateFields((err, values) => {
          if (!err) {
            let valuesParam = {}
            valuesParam = { ...values }
           // this.children.stem = valuesParam['stem'];
            // this.children.directions = valuesParam['directions'];
            this.children.score = valuesParam['score']
            this.children.knowledgePoints = valuesParam['knowledgePoints']
           // this.children.analyseDesc = valuesParam['analyseDesc'];
            this.children.exerciseSrc = valuesParam['exerciseSrc']
            // this.children.analyseUrl = this.analyseUrl;
            this.children.analyseUrl = this.analyseObj.obsObjectKey
            this.children.analyseName = this.analyseObj.obsName
            this.children.optionList.forEach(element => {
                if (element.optionSign == this.rightValue) {
                  element.isRight = 1
                } else {
                  element.isRight = 0
                }
              })
            this.$emit('ok', this.children, this.index)
            this.visible = false
          }
          })
        // this.$refs.realForm.submitForm()
      },
      submitCallback() {
        this.$emit('ok')
        this.visible = false
      },
      handleCancel () {
        this.close()
      }
    },
    created () {
      // const token = Vue.ls.get(ACCESS_TOKEN)
      // this.tokenHeader = { 'X-Access-Token': token }
      const token = Vue.ls.get(ACCESS_TOKEN)
      let tenantid = Vue.ls.get(TENANT_ID)

      this.headers = { 'X-Access-Token': token, 'tenant_id': tenantid }
    },
     computed: {
      uploadAction: function () {
        return this.url.fileUpload
      },
      videoUploadAction: function () {
        return this.url.videoUpload
      }
    }
  }
</script>
<style lang="less" scoped >
  .item-options{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    &:last-child{
      margin-bottom: 0px;
    }
    .item-name{
      padding-right: 10px;
    }
    .item-form{
      flex: 1;
    }
    .right-item{
      padding: 0px 6px;
      margin-left: 10px;
    }
    .item-remove{
      padding: 0px 6px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
</style>
